import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const selectCombinedBalanceState = createSelector(
  (state: RootState) => state.combinedBalance,
  (combinedBalanceState) => combinedBalanceState
);

export const selectCombinedBalanceData = createSelector(
  selectCombinedBalanceState,
  (combinedBalance) => combinedBalance
);
